"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationAction = void 0;
/**
 * Get notification actions
 */
var getNotificationAction = function (instance) {
    return function (id, actionId, config) {
        return instance.get("/notifications/".concat(id, "/actions/").concat(actionId), config);
    };
};
exports.getNotificationAction = getNotificationAction;
